import React from 'react';
import cx from 'classnames';
import {Text} from '@albert-io/atomic';

interface OrderTableProps {
  children: React.ReactNode;
  /** The list's name, when it has no visible heading to point at. */
  label?: string;
  /** The id of the visible heading that names the list. */
  labelledBy?: string;
  className?: string;
}

/**
 * A graded ordering as a wrapping table: a number cell over an item cell per column. A styled
 * list, not a `<table>`, so screen readers announce the item count. The role stays because Safari
 * drops list semantics under `list-style: none`.
 */
export const OrderTable = ({children, label, labelledBy, className}: OrderTableProps) => (
  <ol
    role='list'
    aria-label={label}
    aria-labelledby={labelledBy}
    className={cx('m-x0 flex list-none flex-wrap items-stretch p-x0 pr-px pb-px', className)}
  >
    {children}
  </ol>
);

interface OrderTableCellProps {
  /** The 1-based place in the order. */
  position: number;
  children: React.ReactNode;
}

export const OrderTableCell = ({position, children}: OrderTableCellProps) => (
  <li className='min-w-x0 border-border-primary background-primary -mr-px -mb-px! flex max-w-full flex-col border border-solid'>
    <div className='border-border-primary px-x1-half py-x0-half background-subtle border-0 border-b border-solid text-center'>
      <Text size='s' color='secondary' bold>
        {position}
      </Text>
    </div>
    <div className='min-w-x0 px-x1-half py-x1 flex flex-1 items-center justify-center'>
      {children}
    </div>
  </li>
);
